module.exports = __webpack_public_path__ + "img/rep-02-new.7036f633.png";